<template>
  <v-dialog
      v-model="dialog"
      width="600"
      large
  >
    <template v-slot:activator="{ on, attrs }">
      <v-icon
          v-if="item == null"
          v-bind="attrs"
          v-on="on"
      >
        mdi-plus-box
      </v-icon>
      <v-icon
          v-else
          small
          v-bind="attrs"
          v-on="on"
      >
        mdi-pencil-circle
      </v-icon>
    </template>
    <v-card>
      <v-card-title>
        User
      </v-card-title>
      <v-card-text>
        <v-form
            ref="NewForm"
            v-model="form"
        >
          <v-row>
            <v-col cols="12">
              <v-text-field
                  :rules="[rules.required]"
                  label="User"
                  type="text"
                  v-model="localItem.user"
                  :value="localItem.user"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
                  :rules="[rules.required]"
                  label="First name"
                  type="text"
                  v-model="localItem.first_name"
                  :value="localItem.first_name"
              >
              </v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                  :rules="[rules.required]"
                  label="Last name"
                  type="text"
                  v-model="localItem.last_name"
                  :value="localItem.last_name"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" v-if="localItem.department != null">
              <v-autocomplete
                  :rules="[rules.required]"
                  v-model="localItem.department.id"
                  :items="departmentList"
                  label="Department"
                  clearable
                  hint="Enter department"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
                  :rules="[rules.required]"
                  label="Employee number"
                  type="number"
                  v-model="localItem.employee_number"
                  :value="localItem.employee_number"
              >
              </v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                  label="Floor"
                  type="number"
                  v-model="localItem.floor"
                  :value="localItem.floor"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <v-checkbox
                  label="Active"
                  v-model="localItem.active"
                  :value="localItem.active"
              >
              </v-checkbox>
            </v-col>
            <v-col cols="3">
              <v-checkbox
                  label="Visible"
                  v-model="localItem.visible"
                  :value="localItem.visible"
              >
              </v-checkbox>
            </v-col>
            <v-col cols="3">
              <v-text-field
                  label="Pin code"
                  type="number"
                  v-model="localItem.pin_code"
                  :value="localItem.pin_code"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-textarea
                label="Comment"
                v-model="localItem.comment"
                outlined
            >
            </v-textarea>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn
            @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
            v-if="item == null"
            :disabled="!form"
            @click="onSave"
        >
          Add
        </v-btn>
        <v-btn
            v-else
            :disabled="!form"
            @click="onSave"
        >
          Save
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {mapFields} from "vuex-map-fields";

export default {
  name: 'HumanUserNewEditDialog',
  props: {
    item: {default: null},
    length: {default: null},
    disabled: {default: false}
  },

  computed: {
    ...mapGetters('HumanUser', ['getColumns',]),
    ...mapFields('HumanUser', ['message_error', 'options', 'totalRecords', 'options.page', 'onlyFailedView', 'briefView', 'itemList',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm',
      'isAlive', 'action_loading', 'filters', 'local_phrase', 'lang',]),
    ...mapFields('HRDepartment', {itemListDepartment: 'itemList'},),

    departmentList() {
      let department_list = []
      this.itemListDepartment.forEach(row => department_list.push({
        text: row.department,
        value: row.id
      }))
      return department_list
    },
  },

  methods: {
    ...mapActions('HumanUser', ['fetchSaveItemField']),

    onSave() {
      console.log('onSave', this.localItem)
      let fields_dict = {}
      fields_dict['id'] = this.localItem.id ? this.localItem.id : null
      fields_dict['user'] = this.localItem.user
      fields_dict['first_name'] = this.localItem.first_name
      fields_dict['last_name'] = this.localItem.last_name
      fields_dict['employee_number'] = this.localItem.employee_number
      fields_dict['floor'] = this.localItem.floor
      fields_dict['visible'] = this.localItem.visible === true
      fields_dict['active'] = this.localItem.active === true
      fields_dict['pin_code'] = this.localItem.pin_code
      fields_dict['comment'] = this.localItem.comment
      fields_dict['department'] = {id: this.localItem.department.id}

      this.fetchSaveItemField({
        itemId: this.localItem.id,
        fields_dict: fields_dict,
        dto_model: {to_consumer: 'HumanUserBaseDTO', from_consumer: 'HumanUserBaseDTO'}
      })
      this.dialog = false
      if (this.item === null) {
        this.$refs['NewForm'].resetValidation()
        this.localItem = {
          id: null,
          user: null,
          active: true,
          department: {id: null},
          first_name: null,
          last_name: null,
          employee_number: true,
          visible: true,
          pin_code: null,
          comment: null,
        }
      }
    },
  },

  mounted() {
    // console.log('mounted', this.item)
    if (this.item != null)
      this.localItem = this.item
  },

  data() {
    return {
      dialog: false,
      itemSaved: null,
      form: false,
      localItem: {
        id: null,
        user: null,
        active: true,
        department: {id: null},
        first_name: null,
        last_name: null,
        employee_number: true,
        visible: true,
        pin_code: null,
        comment: null,
      },
      rules: {
        min: len => v => (v || '').length >= len || `Invalid character length, required great or equal ${len}`,
        max: len => v => (v || '').length <= len || `Invalid character length, required low or equal ${len}`,
        required: v => !!v || 'This field is required',
      },
    }
  }
}

</script>


<style scoped lang="scss">
.no-spin input[type='number'] {
  -moz-appearance: textfield;
}

.no-spin input::-webkit-outer-spin-button,
.no-spin input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

</style>